import { useMutation } from '@tanstack/react-query';
import { downloadUnifiedDataFile, fileUpload } from '../../../api/v2/load';

export const useUnifiedDataFileActions = () => {
  const downloadUnifiedDataFileMutation = useMutation({
    mutationFn: ({ loadId, fileName, origin, hsCodes }) =>
      downloadUnifiedDataFile({ loadId, fileName, origin, hsCodes }),
  });

  const uploadUnifiedDataFileMutation = useMutation({
    mutationFn: ({ fileType, formData }) => fileUpload(fileType, formData),
  });

  return { downloadUnifiedDataFileMutation, uploadUnifiedDataFileMutation };
};
